<template>
    <div>
        <form class="form filters">
            <div class="row">
                <div class="col-12">
                    <div class="form__item">
                        <i class="form__icon icons icon-user"></i>
                        <label class="form__label">{{$t('evaluations.filter_evaluations')}}</label>
                        <vue-select label="title" :options="[
                            { title: $t('evaluations.all_evaluations'), value: 'all' },
                            { title: $t('evaluations.pending_evaluations'), value: 'pending' },
                            { title: $t('evaluations.non_pending_evaluations'), value: 'non-pending' }
                        ]" v-model="filter" class="form__select" :class="{ 'has-value': filter }">
                            <template slot="no-options">{{$t('forms.common.no_results')}}</template>
                        </vue-select>
                    </div>
                </div>
            </div>
        </form>
        <div class="table__responsive">
            <table class="table--clickable_rows">
                <thead v-if="!loadingEvaluations  && evaluations.length">
                    <tr>
                        <th>{{$t('evaluations.diploma')}}</th>
                        <th>{{$t('evaluations.qualification')}}</th>
                        <th>{{$t('evaluations.role')}}</th>
                        <th>{{$t('evaluations.level')}}</th>
                        <th>&nbsp;</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingEvaluations" :key="'loading'" class="table--loading">
                        <td colspan="4">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('pending_evaluations.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingEvaluations && !evaluations.length" :key="'no-evaluations'" class="table--empty">
                        <td colspan="4">
                            <div class="text-center">{{$t('pending_evaluations.table.no_evaluations')}}</div>
                        </td>
                    </tr>
                    <tr :class="`table__row--${evaluation.pending ? 'pending' : 'completed'}`" v-for="(evaluation, index) in evaluations" :key="`${evaluation.id}_${index}`" @click="navigateToEvaluation(evaluation)">
                        <td>{{ evaluation.diploma.title }}</td>
                        <td>{{ evaluation.work_process.title }}</td>
                        <td class="table__cell--non_muted"><span>{{ $t('evaluations.roles.' + evaluation.evaluator_role.name) }}</span></td>
                        <td class="table__cell--non_muted"><span :class="mapScoreToState(evaluation).replace(/ /g, '-').toLowerCase()">{{mapScoreToState(evaluation)}}</span></td>
                        <td>
                            <template v-if="!evaluation.is_expired">
                                <i v-if="evaluation.pending === 0" class="mdi mdi-pencil"></i>
                                <i v-else class="mdi mdi-eye"></i>
                            </template>
                        </td>
                    </tr>

                    <tr class="table__navigation" v-if="evaluationsMeta && evaluationsMeta.last_page > 1">
                        <td colspan="4">
                            <pagination :meta="evaluationsMeta" @goToPage="goToPage"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Watch, Prop } from 'vue-property-decorator';
    import { GET_EVALUATIONS } from '@/store/modules/evaluations';
    import Pagination from '@/components/tables/Pagination';
    const comparify = text => (text || '').replace(/[^a-zA-Z]/g, '').toLowerCase();

    @Component({
        components: {
            Pagination,
        }
    })
    export default class EvaluationsTable extends Vue {
        name = 'evaluations-table';
        filter = { title: 'Alle beoordelingen', value: 'all' }; //Todo: make it translatable! + make 'alle beoordelingen' in the dropdown checked, since it is that by default
        userId = 0;
        @Prop() onLoaded;

        mounted() {
            this.userId = this.$route.params.id;
            this.$store.dispatch(GET_EVALUATIONS, { filter: this.filter.value, id: this.userId });
        }

        get evaluations() {
            return this.$store.state.evaluations.evaluations;
        }

        get evaluationsMeta() {
            return this.$store.state.evaluations.evaluationsMeta;
        }

        get loadingEvaluations() {
            return this.$store.state.evaluations.loading;
        }

        @Watch('evaluations')
        onEvaluationsChanged() {
            if (!this.evaluations.length) return;
            if (typeof this.onLoaded === 'function')
                this.onLoaded(this.evaluations[0].student.name);
        }

        @Watch('filter')
        filterByValue(filter = { title: this.$t('evaluations.all_evaluations'), value: 'all' }) {
            console.log('changed filter', filter, this.userId);
            this.$store.dispatch(GET_EVALUATIONS, { filter: filter.value, page: 1, id: this.userId });
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_EVALUATIONS, { filter: this.filter.value, page: pageNo, id: this.userId });
        }

        mapScoreToState(evaluation) {
            if (evaluation.pending) return this.$t('evaluations.pending');
            if (parseInt(evaluation.score) === 1) return this.$t('evaluations.starter');
            if (parseInt(evaluation.score) === 2) return this.$t('evaluations.advanced');
            if (parseInt(evaluation.score) === 3) return this.$t('evaluations.professional');
        }

        navigateToEvaluation(evaluation) {
            if (!evaluation.is_expired) {
                console.log('navigateToEvaluation', evaluation);
                this.$router.push(
                    {
                        name: 'evaluation-student',
                        params: {
                            user_id: evaluation.student.id,
                            diploma_id: evaluation.diploma.diploma_id,
                            work_process_id: evaluation.work_process.work_process_id,
                            evaluation_id: evaluation.id
                        }
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/evaluations/EvaluationsTable.vue